<template>
  <div class="floating-panel" :style="{top: top + 'px'}" :class="{ 'over-scroll': isOverScroll }">
    <slot name="top"></slot>
    <div class="floating-content">
      <div 
        class="sliding-area"
        @touchstart.passive="handleTouchStart"
        @touchmove.passive="handleTouchMove"
        @touchend.passive="handleTouchEnd"
      >
        <!-- <div class="flex-center" style="height: 100%;">
          {{ current ? "下滑展开地图" : "上滑展开完整节点" }} {{ top }}
          <i class="el-icon-arrow-down" :style="{transform: `rotate(${current ? '0' : '180'}deg)`}"></i>
        </div> -->
        <div class="flex-center">
          <div style="width: 40px;height: 5px;border-radius: 3px;overflow: hidden;background-color: #C9C2BB;margin-bottom: 4px;"></div>
        </div>
        <slot name="sliding-area"></slot>
      </div>
      <div style="flex: 1;overflow: hidden;">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * @property {Array<Number>} anchors 锚点 例如：[609,500,348]
 * @property {Number} default-current 弹窗的默认锚点
 */
export default {
  props:{
    anchors:{
      type: Array,
      default: () => []
    },
    defaultCurrent:{
      type: [Number,String],
      default: 0
    }
  },
  data(){
    return {
      top: 0,
      isOverScroll: false,
      startY:0,
      startClientY:0,
      endY:0,
      anchorsList:[],
      current:0,
      dragFrame: null,
      pendingTop: 0,
    }
  },
  watch:{
    anchors:{
      handler(value){
        // 排序
        this.anchorsList = this.deepClone(value).sort((a,b) => b-a);
        this.top = this.current > 0 && this.current < this.anchorsList.length-1 ? this.anchorsList[this.current] : this.anchorsList[0];
      },
      immediate: true,
    }
  },
  created(){
    this.current = +this.defaultCurrent;
  },
  beforeDestroy() {
    if (this.dragFrame) window.cancelAnimationFrame(this.dragFrame);
  },
  methods:{
    handleTouchStart(e){
      this.isOverScroll = false;
      if (this.dragFrame) {
        window.cancelAnimationFrame(this.dragFrame);
        this.dragFrame = null;
      }
      this.startY = Math.round(e.touches[0].pageY);
      let height = window.innerHeight - this.top;
      // 手指按下的位置距离当前弹窗最顶部的距离
      this.startClientY = Math.round(height - (window.innerHeight - this.startY)) ;
    },
    handleTouchMove(e){
      let pageY = Math.round(e.touches[0].pageY);
      let top = Math.round(pageY - this.startClientY);
      // 边界处理
      top = top >= this.anchorsList[0] ? this.anchorsList[0] : top;
      top = top <= this.anchorsList[this.anchorsList.length-1] ? this.anchorsList[this.anchorsList.length-1] : top;
      this.pendingTop = top;
      if (this.dragFrame) return;
      this.dragFrame = window.requestAnimationFrame(() => {
        this.top = this.pendingTop;
        this.dragFrame = null;
      });
    },
    async handleTouchEnd(e){
      if (this.dragFrame) {
        window.cancelAnimationFrame(this.dragFrame);
        this.dragFrame = null;
        this.top = this.pendingTop;
      }
      this.endY = Math.round(e.changedTouches[0].clientY);
      // 确定当前弹窗位置位于哪两个锚点之间
      let index_2 = this.anchorsList.findIndex((findItem,findIndex)=> findIndex ? this.top >= findItem : this.top > findItem);
      let index_1 = index_2 - 1;
      let index_1_value = this.anchorsList[index_1];
      let index_2_value = this.anchorsList[index_2];
      // 计算出当前弹窗更靠近哪个锚点
      let anchorsSpacing = (index_1_value - index_2_value)/2;  //两个锚点的间距的一半
      this.isOverScroll = true;
      if(index_1_value - this.top < anchorsSpacing) {
        this.top = index_1_value;
        this.current = index_1;
      }else {
        this.top = index_2_value;
        this.current = index_2;
      }
      // this.top = index_1_value - this.top < anchorsSpacing ? index_1_value : index_2_value;
      // 这个延迟需要与 .over-scroll 中的动画时长一致
      await this.$sleep(300);
      this.isOverScroll = false;
    }
  }
}
</script>

<style scoped lang="scss">
  .floating-panel {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1002;
    display: flex;
    flex-direction: column;
    .floating-content {
      flex: 1;
      min-height: 0;
      background: transparent;
      border-radius: 8px 8px 0 0;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }
    .sliding-area {
      flex-shrink: 0;
      touch-action: none;
      // height: 20px;
      font-size: 12px;
      line-height: 12px;
      user-select: none;
      // padding: 0 28px;
      // border: 1px solid red;
      // margin: 0 28px;
      .el-icon-arrow-down {
        margin-left: 4px;
      }
    }
  }
  .flex-center {
    display: flex;
    justify-content: center;
  }
  .over-scroll {
    // transition: top .3s cubic-bezier(.62,0,.78,2.14) ;
    transition: top .3s cubic-bezier(.62,0,0,1.85);
  }
</style>